import React, { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';

import { FeatureFlagContextProvider } from '@dndbeyond/character-components/es';
import { featureFlagInfoSelectors } from '@dndbeyond/character-rules-engine/es';

import ErrorBoundary from '../../../Shared/components/ErrorBoundary';
import CharacterSheet from '../CharacterSheet';

export function CharacterSheetContainer(props) {
    const featureFlagInfo = useSelector(featureFlagInfoSelectors.getFeatureFlagInfo);
    useLayoutEffect(() => {
        document
            .getElementsByTagName('body')[0]
            .classList.add(
                'site',
                'body-rpgcharacter-sheet',
                'site-dndbeyond',
                'body-rpgcharacter',
                'body-rpgcharacter-details',
            );
        return () => {
            document
                .getElementsByTagName('body')[0]
                .classList.remove(
                    'site',
                    'body-rpgcharacter-sheet',
                    'site-dndbeyond',
                    'body-rpgcharacter',
                    'body-rpgcharacter-details',
                );
        };
    }, []);
    return (
        <ErrorBoundary>
            <FeatureFlagContextProvider featureFlagInfo={featureFlagInfo}>
                <CharacterSheet />
            </FeatureFlagContextProvider>
        </ErrorBoundary>
    );
}

export default CharacterSheetContainer;
